import React, {useState} from "react";
import {getAuth, sendPasswordResetEmail} from "firebase/auth";

function ForgotPassword({onBack}) {
    const [email,setEmail] = useState("");

    const handleResetPassword = async (e) => {
        e.preventDefault();
        const auth = getAuth();

        if (!email){
            alert("Please enter your email address.");
            return;
        }

        try {
            //sends the verification email automatically 
            await sendPasswordResetEmail(auth, email);
            alert("Password reset email sent! Check your email inbox.");
            onBack(); //back to login screen after sending
        }catch(error) {
            console.error("Reset Error:", error);
            alert("Error: " + error.message);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="bg-white rounded-2x1 p-8 w-full max-w-md mx-4 shadow-2xl relative">

                {/*Header */}
                <h2 className="text-2xl font-bold text-[#5A3E2B] mb-2 text-center">
                    Reset Password
                </h2>
                <p className="text-gray-500 text-center mb-6">
                    Enter your email and we'll send you a link to reset your password.
                </p>

                {/*Form*/}
                <form onSubmit={handleResetPassword} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Email Address
                        </label>
                        <input
                            type="email"
                            placeholder="name@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#FF8C42] focus:ring-2 focus:ring-[#FF8C42]/20 outline-none transition"
                            required    
                        />                
                    </div>

                    <button
                        type="submit"
                        className="w-full py-3 rounded-xl bg-[#FF8C42] text-white font-bold shadow-lg hover:shadow-xl hover:bg-[#e67a35] transition transform active:scale-95"
                        >
                            Send Reset Link
                        </button>
                </form>

                {/*Back Button*/}
                <button
                    onClick={onBack}
                    className="w-full mt-4 text-sm text-gray-500 hover:text-[#5A3E2B] font-medium"
                >
                    ← Back to Login
                </button>
            </div>
        </div>
    );
}

export default ForgotPassword;